import CommunitiesIcon from '@mui/icons-material/Group';
import EventsIcon from '@mui/icons-material/Event';
import ProductsIcon from '@mui/icons-material/ShoppingCart';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { Col, Row } from 'components/Grid';
import Page from 'containers/Page';
import DiscoverMeta from './Meta';

const DiscoverPage = ({
  category,
  children,
  loading,
  onCategoryChange,
  onTypeChange,
  title,
  type,
  value,
}) => {
  const meta = (
    <DiscoverMeta
      category={category}
      onCategoryChange={onCategoryChange}
      onTypeChange={onTypeChange}
      type={type}
      value={value}
    />
  );
  return (
    <Fragment>
      <Page
        links={[
          {
            icon: <EventsIcon />,
            label: 'Events',
            path: '/discover/events',
          },
          {
            icon: <CommunitiesIcon />,
            label: 'Brands',
            path: '/discover/communities',
          },
          {
            icon: <ProductsIcon />,
            label: 'Products',
            path: '/discover/products',
          },
        ]}
        loading={loading}
        rightDrawer={meta}
        title='Discover'
        trackerTitle={`Discover > ${title}`}
      >
        <Row>
          <Col main>{children}</Col>
          <Col meta>{meta}</Col>
        </Row>
      </Page>
    </Fragment>
  );
};

DiscoverPage.propTypes = {
  category: PropTypes.string,
  children: PropTypes.node.isRequired,
  loading: PropTypes.bool,
  onCategoryChange: PropTypes.func.isRequired,
  onTypeChange: PropTypes.func,
  title: PropTypes.string.isRequired,
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
};

export default DiscoverPage;
